import { useNavigate } from "react-router";
import styled from "styled-components";
import { theme } from "../../../helpers/theme";

import { IterationProps, Iterations } from "./iteration";

import mag01 from "../../../../src/assets/icons/mag01.jpg";
import mag02 from "../../../../src/assets/icons/mag02.jpg";
import vector from "../../../../src/assets/icons/vector.svg";
import { ImageSection } from "../faq/components/imageSection";
import { ImageSection_ } from "../faq/components/imageSection_";

const title = `Usługi magazynowe`;
const subTitle1 = `Logistyka magazynowa: Branże: prasa, książka, automotive, 
industrial`;
const desc1 = `Jesteśmy firmą z pasją i wieloletnim doświadczeniem w branży magazynowania i logistyki. Nasza historia 
rozpoczęła się od skromnego magazynu wysokiego składowania w Błoniu, ale szybko rozwinęliśmy naszą 
działalność, aby sprostać rosnącym potrzebom naszych klientów.<br /><br />

Rozwijając się, otworzyliśmy oddział przeładunkowo-magazynowy na Śląsku. To właśnie tam działa 
prężnie nasz oddział spedycji ciężkich materiałów, specjalizujący się w obsłudze dłużyc stalowych i innych 
materiałów o dużym gabarycie. Nasza firma obsługuje klientów na terenie całej Polski oraz w rejonach 
Czech i Słowacji, co pozwala nam dostarczać kompleksowe rozwiązania logistyczne na szeroką skalę.<br /><br />

Nasze wieloletnie doświadczenie w branży magazynowania i logistyki było naszą inspiracją do stworzenia 
innowacyjnej aplikacji. Dzięki zaufaniu i bliskiej współpracy z partnerem z branży rozwoju 
oprogramowania, jesteśmy w stanie dostosować naszą aplikację do potrzeb nawet najbardziej 
wymagających klientów. Ta współpraca umożliwia nam dostarczenie naszym klientom nowoczesnych 
narzędzi, które pomagają w optymalizacji zarządzania magazynem/towarem.<br /><br />

Jesteśmy częścią grupy firm o różnych specjalizacjach, co dodatkowo wzbogaca naszą wiedzę i umożliwia 
nam elastyczne dostosowywanie się do różnorodnych potrzeb klientów. Nasza firma to nie tylko 
przeszłość, to także obecność i przyszłość, w której dążymy do ciągłego rozwoju i doskonalenia naszych 
usług.<br /><br />

Dzięki naszej pasji do logistyki, bogatemu doświadczeniu i zaawansowanym narzędziom jesteśmy gotowi 
stanąć na wysokości zadania i spełnić nawet najbardziej wymagające potrzeby naszych klientów.<br /><br />

Na polskim rynku logistyki magazynowej obserwujemy stały rozwój i wzrost zapotrzebowania na 
profesjonalne usługi, które dostarczają elastyczne rozwiązania dla firm z różnych branż. Nasze 
centra logistyczne są przygotowane, aby obsługiwać wszelkie sektory gospodarki, niezależnie od 
rodzaju towarów czy potrzeb. `;
const subTitle2 = `Logistyka magazynowa IT – software WMS`;
const desc2 = `Do obsługi naszych Klientów dedykujemy opiekuna Klienta oraz stały zespół odpowiedzialny za:`;
const services: IterationProps[] = [
    {
        value: `Cross-dock, przeładunki,`,
        isImage: true,
    },
    {
        value: `Składowanie krótko i długoterminowe w regałach i blokach,`,
        isImage: true,
    },
    {
        value: `Komisjonowanie towaru, picking,`,
        isImage: true,
    },
    {
        value: `Obsługa zwrotów,`,
        isImage: true,
    },
    {
        value: `Zarządzanie pustymi opakowaniami, paletami,`,
        isImage: true,
    },
    {
        value: `Administracja, obsługa stocku i dokumentacji,`,
        isImage: true,
    },
    {
        value: `Recykling,`,
        isImage: true,
    },
    {
        value: `VAS/usługi okołomagazynowe.`,
        isImage: true,
    },
];
const storage: IterationProps[] = [
    {
        value: `Magazyny w Błoniu i Tychach,`,
        isImage: true,
    },
    {
        value: `Składowanie i obróbka,`,
        isImage: true,
    },
    {
        value: `Zarządzanie zwrotami,`,
        isImage: true,
    },
    {
        value: `Value Added Services:`,
        isImage: true,
    },
    {
        value: `- Etykietowanie,`,
        isImage: false,
    },
    {
        value: `- Komisjonowanie,`,
        isImage: false,
    },
    {
        value: `- Pakowanie,`,
        isImage: false,
    },
    {
        value: `- Foliowanie,`,
        isImage: false,
    },
    {
        value: `- Niszczenie,`,
        isImage: false,
    },
    {
        value: `- Recycling.`,
        isImage: false,
    },
];
const software: IterationProps[] = [
    {
        value: `Wprowadzanie, archiwizacje zleceń i dokumentacji,`,
        isImage: true,
    },
    {
        value: `Monitoring zleceń,`,
        isImage: true,
    },
    {
        value: `Raporty bieżące oraz raporty KPI,`,
        isImage: true,
    },
    {
        value: `Rozliczenia i fakturowanie,`,
        isImage: true,
    },
    {
        value: `Proces reklamacyjny,`,
        isImage: true,
    },
    {
        value: `Udział w cyklicznych spotkaniach w celu omawiania bieżącej współpracy.`,
        isImage: true,
    },
]

export const AboutUs = () => {
    return (
        <PageContainer>
            <PageTitle>{title}</PageTitle>

            <Article>
                <ArticleTitle>{subTitle1}</ArticleTitle>
                <ArticleDescription dangerouslySetInnerHTML={{ __html: desc1 }} />
                <TwoColumnInFullScrean>
                    <ImageDiv1></ImageDiv1>
                    <IterationTitle>
                        <p>Oferujemy usługi:</p>
                        {services.map(item =>
                            <Iterations key={item.value} value={item.value} isImage={item.isImage}></Iterations>)}
                    </IterationTitle>
                </TwoColumnInFullScrean>
                <TwoColumnInFullScrean>
                    <IterationTitle>
                        <p>Magazynowanie i VAS:</p>
                        {storage.map(item =>
                            <Iterations key={item.value} value={item.value} isImage={item.isImage}></Iterations>)}
                    </IterationTitle>
                    <img src={vector} style={{
                        height: '250px',
                        rotate: '90deg',
                    }} />
                    {/* <ImageDiv2></ImageDiv2> */}
                </TwoColumnInFullScrean>
            </Article>
            <Article>
                <ArticleTitle>{subTitle2}</ArticleTitle>
                <ArticleDescription>{desc2}</ArticleDescription>
                <TwoColumnInFullScrean>
                    <IterationTitle>
                        {software.map(item =>
                            <Iterations key={item.value} value={item.value} isImage={item.isImage}></Iterations>)}
                    </IterationTitle>
                    <ImageDiv2></ImageDiv2>
                </TwoColumnInFullScrean>
            </Article>
            {/* <ImageSection /> */}
            <ImageSection_ />
        </PageContainer >
    );
};

const PageContainer = styled.div`
padding: 20px 10px;
display: flex;
flex-direction: column;
flex - direction: column;
`;

const PageTitle = styled.h2`
width:100%;
color:${theme.colors.black_primaryText};
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 32px;
line-height: 40px;
margin:0px;
padding-bottom:33px;
`
const TwoColumnInFullScrean = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
padding-bottom:20px;

@media ${theme.device.Mtablet} {
    flex-direction: column;
    justify-content: space-around;
}`

const Article = styled.div`
@media ${theme.device.Mtablet} {
    //background-color:blue;
}`

const ArticleTitle = styled.div`
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight:  ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
//padding: 15px 0px 0px 0px;
padding: 0px;
font-weight: 700;
margin: 0px;
@media ${theme.device.Mtablet} {
}`
const ArticleDescription = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
padding-bottom:20px;
`
const IterationTitle = styled.div`
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 14px;
line-height: 20px;
padding: 10px 0px;
width: 45%;
> p{  
} 
@media ${theme.device.Mtablet} {

   padding: 2% 5%;
   min-width: 240px;
   width: 80%;
}`

const ImageDiv1 = styled.div`
margin-top:20px;
width:50%;
background-image: url(${mag01});
background-repeat: no-repeat;
background-position: center;
background-image: auto;
border-radius: 16px;
min-height:250px;

@media ${theme.device.Mtablet} {
    padding: 2% 5%;
    width:80%;
    margin: auto;
 }`

const ImageDiv2 = styled.div`
margin-top:20px;
width:50%;
background-image: url(${mag02});
background-repeat: no-repeat;
background-position: center;
background-image: auto;
border-radius: 16px;
min-height:250px;

@media ${theme.device.Mtablet} {
    padding: 2% 5%;
    width:80%;
    margin: auto;
 }`


